import { createAction } from '@reduxjs/toolkit';
import {
  CLEAR_FEEDBACK_MESSAGE,
  SET_FEEDBACK_MESSAGE,
  START_POST_SELF_LIMITATION,
  STOP_POST_SELF_LIMITATION,
} from './playResponsibly.config';
import { FeedbackMessage } from './playResponsibly.types';

export const setFeedbackMessage = createAction<
  FeedbackMessage,
  typeof SET_FEEDBACK_MESSAGE
>(SET_FEEDBACK_MESSAGE);

export const clearFeedbackMessage = createAction<
  undefined,
  typeof CLEAR_FEEDBACK_MESSAGE
>(CLEAR_FEEDBACK_MESSAGE);

export const startLoadingPostSelfLimitation = createAction<
  undefined,
  typeof START_POST_SELF_LIMITATION
>(START_POST_SELF_LIMITATION);

export const stopLoadingPostSelfLimitation = createAction<
  undefined,
  typeof STOP_POST_SELF_LIMITATION
>(STOP_POST_SELF_LIMITATION);
